var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.797,
    height: 151.797,
    viewBox: "0 0 151.797 151.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.13,
    x2: 0.5,
    y2: 1.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9dd39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b799d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.62,
    y1: 1.062,
    x2: 0.5,
    y2: 0.26,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09ca2b",
    stopOpacity: 0.769
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#48a318",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#629d11",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.213,
    y1: 0.257,
    x2: 0.681,
    y2: 1.068,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26343",
    "data-name": "Group 26343",
    transform: "translate(17284.314 241.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26299",
    "data-name": "Group 26299",
    transform: "translate(-17284.314 -241.762)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5266",
    "data-name": "Group 5266",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18575",
    "data-name": "Path 18575",
    d: "M75.9,0A75.9,75.9,0,1,1,0,75.9,75.9,75.9,0,0,1,75.9,0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "error-2",
    "data-name": "error",
    transform: "translate(24.109 29.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10105",
    "data-name": "Path 10105",
    d: "M92.85,3.369h-59.4L18.726,0,0,11.922.318,90.107A100.917,100.917,0,0,0,19.74,102.948c11.158,5.565,29.245,6.85,29.245,6.85s15.532-.124,28.4-4.5a80.523,80.523,0,0,0,23.066-13.009V11.922Z",
    transform: "translate(0 12.389)",
    opacity: 0.342,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "transfer",
    transform: "translate(1.204 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M23.776,47.563a7.077,7.077,0,0,1-5.041-2.092L2.09,28.826a7.135,7.135,0,0,1,0-10.091L18.735,2.09A7.136,7.136,0,0,1,28.826,12.182l-11.6,11.6,11.6,11.6a7.129,7.129,0,0,1-5.05,12.174Z",
    transform: "translate(1.475 1.472)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10107_-_Outline",
    "data-name": "Path 10107 - Outline",
    d: "M25.244,50.508a8.515,8.515,0,0,1-6.086-2.527L2.517,31.34a8.618,8.618,0,0,1,0-12.174L19.162,2.521A8.608,8.608,0,0,1,31.335,14.695L20.773,25.258,31.335,35.82a8.6,8.6,0,0,1-6.092,14.688Zm0-47.563a5.626,5.626,0,0,0-4,1.659L4.6,21.248a5.67,5.67,0,0,0,0,8.009L21.244,45.9a5.593,5.593,0,0,0,4,1.661A5.656,5.656,0,0,0,29.253,37.9L16.608,25.258,29.253,12.613a5.663,5.663,0,0,0-4-9.668Z",
    transform: "translate(0.006 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M85.6,14.267H7.133A7.133,7.133,0,0,1,7.133,0H85.6a7.133,7.133,0,0,1,0,14.267Z",
    transform: "translate(3.85 18.124)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108_-_Outline",
    "data-name": "Path 10108 - Outline",
    d: "M87.073,17.212H8.606A8.606,8.606,0,0,1,8.606,0H87.073a8.606,8.606,0,0,1,0,17.212ZM8.606,2.945a5.661,5.661,0,0,0,0,11.322H87.073a5.661,5.661,0,0,0,0-11.322Z",
    transform: "translate(2.378 16.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M7.131,47.573A7.138,7.138,0,0,1,2.09,35.389l11.6-11.6-11.6-11.6A7.136,7.136,0,0,1,12.181,2.09L28.826,18.735a7.136,7.136,0,0,1,0,10.091L12.181,45.471A7.085,7.085,0,0,1,7.131,47.573Z",
    transform: "translate(65.675 49.019)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109_-_Outline",
    "data-name": "Path 10109 - Outline",
    d: "M8.6,50.517A8.515,8.515,0,0,1,2.514,47.99a8.617,8.617,0,0,1,0-12.17L13.08,25.258,2.518,14.695A8.608,8.608,0,1,1,14.691,2.521L31.336,19.166a8.618,8.618,0,0,1,0,12.174L14.691,47.984A8.528,8.528,0,0,1,8.6,50.517Zm0-47.573a5.663,5.663,0,0,0-4,9.668L17.244,25.258,4.6,37.9a5.67,5.67,0,0,0,0,8.009,5.646,5.646,0,0,0,8.006-.006L29.253,29.257a5.67,5.67,0,0,0,0-8.009L12.609,4.6A5.626,5.626,0,0,0,8.6,2.945Z",
    transform: "translate(64.206 47.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    "data-name": "Path 10110",
    d: "M85.6,14.267H7.133A7.133,7.133,0,0,1,7.133,0H85.6a7.133,7.133,0,0,1,0,14.267Z",
    transform: "translate(1.472 65.68)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10110_-_Outline",
    "data-name": "Path 10110 - Outline",
    d: "M87.073,17.212H8.606A8.606,8.606,0,0,1,8.606,0H87.073a8.606,8.606,0,0,1,0,17.212ZM8.606,2.945a5.661,5.661,0,0,0,0,11.322H87.073a5.661,5.661,0,0,0,0-11.322Z",
    transform: "translate(0 64.208)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferPayment);
export default __webpack_public_path__ + "static/media/transfer-payment.b1a99dec9e761e4131461b200e46af16.svg";
export { ForwardRef as ReactComponent };